module.exports = __webpack_public_path__ + "img/18_rain.c9f1e026.jpg";